import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import UsersList from "../../Modals/usersList";
import { useGetAdminNotification } from "../../api/hooks/useNotification";
import { NOTIFICATION_TYPE } from "../../api/types/notification.types";
import { CircularProgress, Box } from "@mui/material";

const NotificationDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;

  const { data: notificationData, isLoading, error } = useGetAdminNotification(id);
  const notification = notificationData?.data;

  const [openUserModal, setOpenUserModal] = React.useState(false);

  // We don't have the full usersList object with labels/avatars here, 
  // but we can show the IDs or a message. For now, we'll keep it consistent with the list logic.
  const usersList: any[] = [];

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error || !notification) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
        <p>Failed to load notification details.</p>
      </Box>
    );
  }

  const handleOpenAudience = () => {
    setOpenUserModal(true);
  };

  const getTypeLabel = (type: number) => {
    if (type === NOTIFICATION_TYPE.BROADCAST) return "Broadcast";
    if (type === NOTIFICATION_TYPE.MAIL) return "Email";
    return "Unknown";
  };

  const formatDate = (dateString: string) => {
    if (!dateString) return "--";
    return new Date(dateString).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).replace(/ /g, "-");
  };

  return (
    <>
      <div className="main_title">
        <h1>Notification Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/manage-notifications")}>
            Notification & Communication Center
          </button> -
          Notification Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          {/* <div className="vew_img no_radius w_100">
                        <h6>Image</h6>
                        <figure>
                            <img alt="user" src="/static/images/placeholder.png" />
                        </figure>
                    </div> */}
          <div className="w_100">
            <h6>Notification Title</h6>
            <p>{notification.title}</p>
          </div>
          <div className="w_33">
            <h6>Type</h6>
            <p>{getTypeLabel(notification.type)}</p>
          </div>
          <div className="w_33">
            <h6>Audience</h6>
            <p>
              {notification.isSendToAll ? (
                "All Users"
              ) : (
                <button className="anchor_link" onClick={handleOpenAudience}>
                  {notification.userIds?.length || 0} Users
                </button>
              )}
            </p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>{formatDate(notification.createdAt)}</p>
          </div>
          <div className="w_100">
            <h6>Notification Message</h6>
            <p>{notification.message}</p>
          </div>
        </div>
      </div>

      <UsersList
        open={openUserModal}
        onClose={() => setOpenUserModal(false)}
        setOpen={setOpenUserModal}
        userIds={notification.userIds || []}
        usersList={usersList}
      />
    </>
  );
};

export default NotificationDetail;
